import { UnitSystem } from 'src/app/shared/enums/unit-system.enum';

/** Normalize results payload to a fixed shape for rendering */
export function normalizeGeothermalResults(payload: any): {
  thermalCollapseResponses: any[];
  unsupportedLengthResponses: any;
} | null {
  if (!payload) return null;

    // Prefer stable keys but support legacy/load variants
    const thermalCollapse = payload.thermalCollapseResponses
      ?? payload.thermalCollapseOutput
      ?? [];
    const unsupportedLength = payload.unsupportedBucklingResponses
      ?? payload.unsupportedBucklingOutput
      ?? {};

  return {
    thermalCollapseResponses: Array.isArray(thermalCollapse) ? thermalCollapse : (thermalCollapse ?? []),
    unsupportedLengthResponses: unsupportedLength ?? {}
  };
}

/** Parse unit system from backend string; if not recognized, return null */
export function parseUnitSystem(value: any): UnitSystem | null {
  if (value === 'SI') return UnitSystem.SI;
  if (value === 'USC' || value === 'US') return UnitSystem.USC;
  return null;
}
